import Currency from 'components/Currency'
import I18n from 'components/I18n'
import Money from 'components/Money'
import messages from 'lang'
import React from 'react'
import styled from 'styled-components'
import { color } from 'utils/styledHelper'

const FeeWrapper = styled.p`
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 150%;
  color: ${color('body')};
  margin: 0.5rem 0 0 0;
`

const Amount = styled.b`
  color: ${color('white')};
`

type Props = {
  amount: number | string
  currency: string
  withdrawal?: string
}

const Fee = ({ amount, currency, withdrawal }: Props) => (
  <FeeWrapper>
    {!withdrawal && (
      <I18n
        currency={<Currency code={currency} />}
        data={messages.withdrawal_fee_amount_1}
        fee={
          <Amount data-e2e='withdrawFee'>
            <Money amount={amount} currency={currency} />
          </Amount>
        }
      />
    )}
    {withdrawal && (
      <I18n
        data={messages.withdrawal_fee_amount_2}
        fee={
          <Amount data-e2e='withdrawFee'>
            <Money amount={amount} currency={currency} />
          </Amount>
        }
        currency={<Currency code={currency} />}
        withdrawal={withdrawal}
      />
    )}
  </FeeWrapper>
)

export default Fee
